/**
 * Message Types for when the client sends a message (it will get propagated into the same event bus)
 */

export enum BridgeMessageTypes {
  DebugMessage = 'debugMessage',
  ErrorMessage = 'errorMessage',
  NavigateToURL = 'navigateToURL',
  AnalyticsEvent = 'analyticsEvent',
  CloseChat = 'closeChat',
  StartChat = 'startChat',
  EndChat = 'endChat',
  ChangeOrientation = 'changeOrientation',
  NavigateToURLMweb = 'navigateToURLMweb',
  MinimizeChat = 'minimizeChat'
}

export type DebugMessage = {
  type: BridgeMessageTypes;
  message: string;
};

export type ErrorMessage = {
  type: BridgeMessageTypes;
  message: string;
  code: number;
};

export type NavigateToURLMessage = {
  type: BridgeMessageTypes;
  url: string;
};

export type AnalyticsEventMessage = {
  type: BridgeMessageTypes;
  subtype: string;
  data: 50;
};

export type CloseChatMessage = {
  type: BridgeMessageTypes;
  closeView: boolean;
};

export type StartChatMessage = {
  type: BridgeMessageTypes;
  chatSessionId: string;
  chatEngagementId: string;
  chatSessionAttributes: string; // WarmSessionContext
};

export type EndChatMessage = {
  type: BridgeMessageTypes;
};

export type MinimizeChatMessage = {
  type: BridgeMessageTypes;
  reason: string;
};

/**
 * This Sum Type describes the set of System Messages that are transmittable to NMA.
 */
type Message = DebugMessage | ErrorMessage | NavigateToURLMessage | AnalyticsEventMessage | CloseChatMessage | StartChatMessage | EndChatMessage | MinimizeChatMessage;

export default Message;
